module.exports = __webpack_public_path__ + "static/mreavesxlsannaru-020415006EmigreWebOnly-8938780bd8aeb49e033071c9c7a044db.ttf";